import { t } from 'i18next';
import { useContext, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import DebouncedSearchBox from '~components/Search/DebouncedSearchBox';

import DriverPayQueryContext from '../../DriverPayQueryContext';

export default function Search() {
  const driverPayQuery = useContext(DriverPayQueryContext);
  const [searchParams, setSearchParams] = useSearchParams();

  const initialSearchValue = useMemo(() => {
    return searchParams.get('search') ?? '';
  }, [searchParams.get('search')]);

  const handleSearchChange = (searchQuery: string) => {
    driverPayQuery.applySearchQuery(searchQuery);

    // Sync search query with URL
    setSearchParams(
      (prevParams) => {
        const newParams = new URLSearchParams(prevParams);
        if (searchQuery) {
          newParams.set('search', searchQuery);
        } else {
          newParams.delete('search');
        }
        return newParams;
      },
      { replace: true },
    );
  };

  return (
    <DebouncedSearchBox
      initialValue={initialSearchValue}
      onChange={handleSearchChange}
      placeholder={`${t('form_fields.search')}`}
    />
  );
}
